export class PaytronixApiError extends Error {
  code;

  constructor({ message, code }) {
    super(message);
    this.code = code;
  }
}

export const DiscountsErrorCode = {
  INVALID_CARD_NUMBER: 'transaction.invalid_card_number',
};

export const EnrollmentErrorCode = {
  DUPLICATE_PHONE_NUMBER: 'sms_enroll.phone_number_already_enrolled',
  INVALID_PHONE_NUMBER: 'sms_enroll.invalid_input',
};

export const SearchCustomersErrorCode = {
  INVALID_USER_DATA: 'transaction.user_data_error',
};
